var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { isolateComponent } from '@zapier/style-encapsulation';
import { Icon } from '../../display/Icon';
import { TooltipWrapper } from '../../display/TooltipWrapper';
import { BaseButton, } from '../../navigation/Button/BaseButton';
export function BaseIconButton(_a) {
    var { icon, iconSize = 24, isCircle, label, shouldCorrectTooltipPosition, tooltipId, tooltipPosition } = _a, buttonProps = __rest(_a, ["icon", "iconSize", "isCircle", "label", "shouldCorrectTooltipPosition", "tooltipId", "tooltipPosition"]);
    return (isolateComponent(TooltipWrapper, { content: label, position: tooltipPosition, shouldCorrectPosition: shouldCorrectTooltipPosition, showTooltipOnTouchDevices: false, tooltipId: tooltipId }, ({ childProps }) => (isolateComponent(BaseButton, Object.assign({ ariaLabel: label }, buttonProps, childProps, { isPill: isCircle, isSquare: true }),
        isolateComponent(Icon, { canAcceptPointerEvents: false, isBlock: true, name: icon, size: iconSize })))));
}
//# sourceMappingURL=BaseIconButton.js.map
// @zapier/design-system@6.27.0 (617a97f69)
